import { render, staticRenderFns } from "./form-text-field.vue?vue&type=template&id=4a51a2fa&scoped=true&"
import script from "./form-text-field.vue?vue&type=script&lang=js&"
export * from "./form-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51a2fa",
  null
  
)

export default component.exports